// @flow
import * as React from 'react';

import { Base } from '@gandi/ui';

import styles from './Row.scss';

type Props = {|
  children: React.Node,
  fullRow?: boolean,
|};

export default function Row({
  children,
  fullRow,
}: Props): React.Element<typeof Base> {
  const props = fullRow ? {} : { flex: true, flexWrap: true };
  return (
    <Base {...props} className={styles.root}>
      {children}
    </Base>
  );
}
